// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__5bWCs","left":"styles_left__2NCSQ"};